import { render } from "./affirmation.vue?vue&type=template&id=01a111d3"
import script from "./affirmation.vue?vue&type=script&lang=js"
export * from "./affirmation.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/stages_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__